import { injectStores } from '@mobx-devtools/tools';
import {
  IdempotencyKeyStore,
  IdempotencyKeyStoreDefault
} from '@src/Common/Services/Idempotency/IdempotencyKey.store';
import {
  AdvanceFilterStore,
  AdvanceFilterStoreDefault,
  IAdvanceFilterStore
} from '@src/Domain/AdvanceFilter/AdvanceFilterStore';
import {
  AllEventStore,
  AllEventStoreDefault,
  IAllEventStore
} from '@src/Domain/AllEvent/AllEventStore';
import {
  CountryStore,
  CountryStoreDefault,
  ICountryStore
} from '@src/Domain/Country/Country.store';
import {
  DUMEvents,
  IDUMEventsDefault,
  IDUMEventsStore
} from '@src/Domain/DUMEvents/DUMEvents.store';
import {
  FormStore,
  FormStoreDefault,
  IFormStore
} from '@src/Domain/Form/Form.store';
import {
  IMySubmissionStore,
  MySubmissionStore,
  MySubmissionStoreDefault
} from '@src/Domain/MySubmission/MySubmission.store';
import { IUiStore, UiStore, UiStoreDefault } from '@src/Domain/Ui/Ui.store';
import {
  IUserStore,
  UserStore,
  UserStoreDefault
} from '@src/Domain/User/User.store';
import {
  IUserFeedbackStore,
  UserFeedbackStore,
  UserFeedbackStoreDefault
} from '@src/Domain/UserFeedback/UserFeedback.store';
import { configure } from 'mobx';
configure({ useProxies: 'never', enforceActions: 'never' });

export class RootStore {
  UserStore: IUserStore;
  IdempotencyKeyStore: IdempotencyKeyStore;
  DUMEventStore: IDUMEventsStore;
  FormStore: IFormStore;
  CountryStore: ICountryStore;
  AllEventStore: IAllEventStore;
  AdvanceFilterStore: IAdvanceFilterStore;
  MySubmissionStore: IMySubmissionStore;
  UserFeedbackStore: IUserFeedbackStore;
  UiStore: IUiStore;

  constructor() {
    this.UserStore = new UserStore();
    this.IdempotencyKeyStore = new IdempotencyKeyStore();
    this.DUMEventStore = new DUMEvents(this);
    this.FormStore = new FormStore();
    this.CountryStore = new CountryStore();
    this.AllEventStore = new AllEventStore(this);
    this.AdvanceFilterStore = new AdvanceFilterStore();
    this.MySubmissionStore = new MySubmissionStore(this);
    this.UserFeedbackStore = new UserFeedbackStore();
    this.UiStore = new UiStore();
  }
}

export const defaulStore: RootStore = {
  UserStore: UserStoreDefault,
  IdempotencyKeyStore: IdempotencyKeyStoreDefault,
  DUMEventStore: IDUMEventsDefault,
  FormStore: FormStoreDefault,
  CountryStore: CountryStoreDefault,
  AllEventStore: AllEventStoreDefault,
  AdvanceFilterStore: AdvanceFilterStoreDefault,
  MySubmissionStore: MySubmissionStoreDefault,
  UserFeedbackStore: UserFeedbackStoreDefault,
  UiStore: UiStoreDefault
};

injectStores({ rootStore: new RootStore() });
